import React, { Component } from 'react';
import './RandomBlogSite.css';

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    console.log(this.props.headerFont)
    console.log(this.props.bodyFont)
  }

  componentDidUpdate() {
    var selects = document.getElementsByClassName("accent-a");
    for (var i = 0, il = selects.length; i < il; i++) {
      selects[i].style.color = this.props.accentColor;
    }
  }

  componentDidMount() {
    var selects = document.getElementsByClassName("accent-a");
    for (var i = 0, il = selects.length; i < il; i++) {
      selects[i].style.color = this.props.accentColor;
    }
  }

  render() {
    return (
      <div
        className="bodywrap"
        style={{
          backgroundColor: this.props.backgroundColor,
          color: this.props.baseColor,
          fontFamily: this.props.bodyFont,
        }}
      >
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.headerFont} />
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.bodyFont} />
        <div className="container" style={{ fontFamily: this.props.bodyFont }}>
          <div className="row justify-content-center">

            <div className="col-md-8">
              <header className="blog-header py-3">
                <div className="row flex-nowrap justify-content-between align-items-center">
                  <div className="col-4 pt-1">
                    <span className="">Subscribe</span>
                  </div>
                  <div className="col-4 text-center">
                    <a className="blog-header-logo accent-a" href="#">Blog name here</a>
                  </div>
                  <div className="col-4 d-flex justify-content-end align-items-center">
                    <span className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="mx-3"><circle cx="10.5" cy="10.5" r="7.5"></circle><line x1="21" y1="21" x2="15.8" y2="15.8"></line></svg>
                    </span>
                    <a className="btn btn-sm btn-outline-secondary" href="#">Sign up</a>
                  </div>
                </div>
              </header>

              <div className="nav-scroller py-1 mb-2">
                <nav className="nav d-flex justify-content-between">
                  <a className="p-2 accent-a" href="#">World</a>
                  <a className="p-2 accent-a" href="#">U.S.</a>
                  <a className="p-2 accent-a" href="#">Technology</a>
                  <a className="p-2 accent-a" href="#">Design</a>
                  <a className="p-2 accent-a" href="#">Culture</a>
                  <a className="p-2 accent-a" href="#">Business</a>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <main role="main" className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 blog-main">

              <div className="blog-post">
                <img src={this.props.imageUrl} />

                <h2 style={{ fontFamily: this.props.headerFont }} className="blog-post-title">Sample blog post</h2>
                <p className="blog-post-meta">January 1, 2014 by <a href="#" className="accent-a">Mark</a></p>

                <p>This blog post shows a few different types of content that's supported and styled with Bootstrap. Basic typography, images, and code are all supported.</p>
                <hr />
                <p>Cum sociis natoque penatibus et magnis <a href="#" className="accent-a">dis parturient montes</a>, nascetur ridiculus mus. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Sed posuere consectetur est at lobortis. Cras mattis consectetur purus sit amet fermentum.</p>
                <blockquote>
                  <p>Curabitur blandit tempus porttitor. <strong>Nullam quis risus eget urna mollis</strong> ornare vel eu leo. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
                </blockquote>
                <p>Etiam porta <em>sem malesuada magna</em> mollis euismod. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.</p>
                <h2 style={{ fontFamily: this.props.headerFont }}>Heading</h2>
                <p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
                <h3>Sub-heading</h3>
                <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                <p>Aenean lacinia bibendum nulla sed consectetur. Etiam porta sem malesuada magna mollis euismod. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa.</p>
                <h3>Sub-heading</h3>
                <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean lacinia bibendum nulla sed consectetur. Etiam porta sem malesuada magna mollis euismod. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.</p>
                <ul>
                  <li>Praesent commodo cursus magna, vel scelerisque nisl consectetur et.</li>
                  <li>Donec id elit non mi porta gravida at eget metus.</li>
                  <li>Nulla vitae elit libero, a pharetra augue.</li>
                </ul>
                <p>Donec ullamcorper nulla non metus auctor fringilla. Nulla vitae elit libero, a pharetra augue.</p>
                <ol>
                  <li>Vestibulum id ligula porta felis euismod semper.</li>
                  <li>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</li>
                  <li>Maecenas sed diam eget risus varius blandit sit amet non magna.</li>
                </ol>
                <p>Cras mattis consectetur purus sit amet fermentum. Sed posuere consectetur est at lobortis.</p>
              </div>

              <div className="blog-post">
                <img src={this.props.imageUrl} />
                <h2 style={{ fontFamily: this.props.headerFont }} className="blog-post-title">Another blog post</h2>
                <p className="blog-post-meta">December 23, 2013 by <a href="#" className="accent-a">Jacob</a></p>

                <p>Cum sociis natoque penatibus et magnis <a href="#" className="accent-a">dis parturient montes</a>, nascetur ridiculus mus. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Sed posuere consectetur est at lobortis. Cras mattis consectetur purus sit amet fermentum.</p>
                <blockquote>
                  <p>Curabitur blandit tempus porttitor. <strong>Nullam quis risus eget urna mollis</strong> ornare vel eu leo. Nullam id dolor id nibh ultricies vehicula ut id elit.</p>
                </blockquote>
                <p>Etiam porta <em>sem malesuada magna</em> mollis euismod. Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.</p>
                <p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>
              </div>
              <hr />
              <footer className="blog-footer text-center">
                <p>Yet another Bootstrap-looking footer</p>
                <p>
                  <a href="#" className="accent-a">Back to top</a>
                </p>
              </footer>
            </div>

          </div>
        </main>

      </div >

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/RandomBlogSite.js